/* Nohancy — comportements des sections nh-* (JS vanilla, sans dépendance). */
(function () {
  if (window.__nohancy) return;
  window.__nohancy = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  /* Le bloc produit et sa barre mobile (qui peut être déplacée ailleurs dans la page par un thème) */
  function scopeOf(el) {
    var s = el.closest('[data-nh-product]');
    if (s) return s;
    var f = el.closest('[data-nh-for]');
    return f ? document.querySelector('[data-nh-product][data-section="' + f.getAttribute('data-nh-for') + '"]') : null;
  }
  function all(scope, sel) {
    var out = Array.prototype.slice.call(scope.querySelectorAll(sel));
    document.querySelectorAll('[data-nh-for="' + scope.getAttribute('data-section') + '"]').forEach(function (bar) {
      if (!scope.contains(bar)) out = out.concat(Array.prototype.slice.call(bar.querySelectorAll(sel)));
    });
    return out;
  }

  /* ——— Compte à rebours d'expédition : avant l'heure limite → « aujourd'hui », après → « demain » ——— */
  function tickCountdowns() {
    document.querySelectorAll('[data-nh-product][data-cutoff]').forEach(function (el) {
      var out = el.querySelector('[data-nh-countdown]');
      if (!out) return;
      var now = new Date();
      var cutoff = new Date(now);
      cutoff.setHours(parseInt(el.getAttribute('data-cutoff'), 10) || 14, 0, 0, 0);
      var day = 'aujourd’hui';
      if (now >= cutoff) { cutoff.setDate(cutoff.getDate() + 1); day = 'demain'; }
      var left = Math.max(0, Math.floor((cutoff - now) / 1000));
      out.textContent = Math.floor(left / 3600) + ' h ' + pad(Math.floor((left % 3600) / 60)) + ' min ' + pad(left % 60) + ' s';
      var d = el.querySelector('[data-nh-shipday]');
      if (d) d.textContent = day;
    });
  }

  /* ——— Accordéons : onglets produit et FAQ (un seul ouvert à la fois par groupe) ——— */
  function setOpen(item, open) {
    var btn = item.querySelector('[data-nh-acc-btn]');
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    var sign = item.querySelector('[data-nh-acc-sign]');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (panel) panel.hidden = !open;
    if (sign) sign.textContent = open ? '−' : '+';
    item.classList.toggle('is-open', open);
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-nh-acc-btn]');
    if (!btn) return;
    var item = btn.closest('[data-nh-acc]');
    var wasOpen = btn.getAttribute('aria-expanded') === 'true';
    item.parentNode.querySelectorAll(':scope > [data-nh-acc]').forEach(function (o) { setOpen(o, false); });
    setOpen(item, !wasOpen);
  });

  /* ——— Bandeau : rotation des messages ——— */
  function startBanners() {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('[data-nh-ann]').forEach(function (el) {
      if (el.__nhAnn) return;
      var msgs = el.querySelectorAll('.nh-ann__msg');
      if (msgs.length < 2) return;
      var i = 0;
      el.__nhAnn = setInterval(function () {
        if (document.hidden) return;
        msgs[i].classList.remove('is-on');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('is-on');
      }, Math.max(2000, parseInt(el.getAttribute('data-interval'), 10) || 4000) * (reduce ? 1.5 : 1));
    });
  }
  document.addEventListener('shopify:section:load', startBanners);

  /* ——— Menu mobile de l'en-tête ——— */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-nh-burger]');
    if (!b) return;
    var nav = document.getElementById(b.getAttribute('aria-controls'));
    if (!nav) return;
    var open = nav.hidden;
    nav.hidden = !open;
    b.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* ——— Galerie : clic sur une miniature ——— */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-nh-thumb]');
    if (!t) return;
    var scope = t.closest('[data-nh-product]');
    var i = t.getAttribute('data-nh-thumb');
    scope.querySelectorAll('[data-nh-thumb]').forEach(function (b) { b.classList.toggle('is-on', b === t); });
    var imgs = scope.querySelectorAll('[data-nh-gal-img]');
    imgs.forEach(function (img) { img.hidden = img.getAttribute('data-nh-gal-img') !== i; });
    var label = scope.querySelector('[data-nh-gal-label]');
    if (label && !imgs.length) label.textContent = '[' + t.getAttribute('data-label') + ']';
  });

  /* ——— Sélecteur d'offres → bouton, barre mobile, variante à ajouter ——— */
  function selectOffer(scope, btn) {
    scope.querySelectorAll('[data-nh-offer]').forEach(function (o) {
      var on = o === btn;
      o.classList.toggle('is-on', on);
      o.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    var id = btn.getAttribute('data-variant-id');
    var qty = btn.getAttribute('data-qty') || '1';
    var available = btn.getAttribute('data-available') === 'true';
    var price = btn.getAttribute('data-price');
    var old = btn.getAttribute('data-old');
    all(scope, '[data-nh-add]').forEach(function (a) {
      a.setAttribute('data-variant-id', id);
      a.setAttribute('data-qty', qty);
      if (available) a.removeAttribute('aria-disabled'); else a.setAttribute('aria-disabled', 'true');
    });
    var q = function (s) { return all(scope, s)[0] || null; };
    if (q('[data-nh-cta-price]')) q('[data-nh-cta-price]').textContent = price;
    if (q('[data-nh-cta-old]')) { q('[data-nh-cta-old]').textContent = old; q('[data-nh-cta-old]').hidden = !old; }
    if (q('[data-nh-cta-label]')) q('[data-nh-cta-label]').textContent = available ? (scope.getAttribute('data-cta') || 'Ajouter au panier') : 'Épuisé';
    if (q('[data-nh-bar-title]')) q('[data-nh-bar-title]').textContent = btn.getAttribute('data-title');
    if (q('[data-nh-bar-price]')) q('[data-nh-bar-price]').textContent = price;
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-nh-offer]');
    if (btn) selectOffer(scopeOf(btn), btn);
  });
  document.addEventListener('keydown', function (e) {
    var btn = e.target.closest && e.target.closest('[data-nh-offer]');
    if (!btn || ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].indexOf(e.key) < 0) return;
    var all = Array.prototype.slice.call(btn.parentNode.querySelectorAll('[data-nh-offer]'));
    var i = all.indexOf(btn) + (e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : -1);
    var next = all[(i + all.length) % all.length];
    next.focus();
    selectOffer(scopeOf(btn), next);
    e.preventDefault();
  });

  /* ——— Ajout au panier (/cart/add.js) ——— */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-nh-add]');
    if (!a) return;
    e.preventDefault();
    if (a.getAttribute('aria-disabled') === 'true' || a.classList.contains('is-loading')) return;
    var scope = scopeOf(a);
    var err = scope.querySelector('[data-nh-error]');
    if (err) err.hidden = true;
    a.classList.add('is-loading');
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(a.getAttribute('data-variant-id')), quantity: Number(a.getAttribute('data-qty') || 1) }] })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j.description || res.j.message || 'Erreur');
        document.dispatchEvent(new CustomEvent('nohancy:cart:added', { detail: res.j }));
        var action = scope.getAttribute('data-cart-action');
        if (action === 'checkout') { window.location.href = root + 'checkout'; return; }
        a.classList.remove('is-loading');
        if (action === 'drawer' && NHCart.hasDrawer()) NHCart.open(); else window.location.href = root + 'cart';
      })
      .catch(function (x) {
        a.classList.remove('is-loading');
        if (err) { err.textContent = x.message; err.hidden = false; }
      });
  });


  /* ——— Panier Nohancy (latéral + page /cart), rendu depuis /cart.js ——— */
  var NHCart = (function () {
    var drawer = function () { return document.querySelector('[data-nh-drawer]'); };
    var page = function () { return document.querySelector('[data-nh-cartpage]'); };
    var lastFocus = null;
    function fmt(cents, format) {
      format = format || '{{amount_with_comma_separator}} €';
      var n = (cents || 0) / 100;
      function sep(dec, th, d) { var p = n.toFixed(dec).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th); return p[0] + (p[1] ? d + p[1] : ''); }
      return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
        return { amount: sep(2, ',', '.'), amount_no_decimals: sep(0, ',', '.'), amount_with_comma_separator: sep(2, '.', ','),
          amount_no_decimals_with_comma_separator: sep(0, '.', ','), amount_with_apostrophe_separator: sep(2, "'", '.'),
          amount_with_space_separator: sep(2, ' ', ',') }[k] || sep(2, '.', ',');
      }).replace(/<[^>]*>/g, '');
    }
    function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; }
    function img(url, w) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
    function targets() { return [drawer(), page()].filter(Boolean); }
    function render(cart) {
      document.querySelectorAll('[data-nh-cart-count]').forEach(function (c) { c.textContent = cart.item_count; c.hidden = !cart.item_count; });
      targets().forEach(function (root) {
        var f = root.getAttribute('data-money-format');
        var list = root.querySelector('[data-nh-cart-items]');
        var empty = root.querySelector('[data-nh-cart-empty]');
        var foot = root.querySelector('[data-nh-cart-foot]') || document.querySelector('[data-nh-cart-foot]');
        var label = root.querySelector('[data-nh-cart-count-label]');
        if (label) label.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
        empty.hidden = cart.item_count > 0;
        if (foot) foot.hidden = !cart.item_count;
        list.innerHTML = cart.items.map(function (it, i) {
          var discounted = it.original_line_price > it.final_line_price;
          var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<span class="nh-item__variant">' + esc(it.variant_title) + '</span>' : '';
          var allocs = (it.line_level_discount_allocations || []).map(function (d) { return '<span class="nh-item__deal">' + esc(d.discount_application.title) + '</span>'; }).join('');
          return '<div class="nh-item" data-line="' + (i + 1) + '">' +
            '<a class="nh-item__img" href="' + esc(it.url) + '">' + (it.image ? '<img src="' + img(it.image, 160) + '" alt="" width="80" height="80" loading="lazy">' : '') + '</a>' +
            '<div class="nh-item__info"><a class="nh-item__title" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + variant + allocs +
            '<div class="nh-item__qty" role="group" aria-label="Quantité">' +
              '<button type="button" data-nh-qty="' + (it.quantity - 1) + '" aria-label="Retirer un">−</button>' +
              '<span aria-live="polite">' + it.quantity + '</span>' +
              '<button type="button" data-nh-qty="' + (it.quantity + 1) + '" aria-label="Ajouter un">+</button>' +
            '</div></div>' +
            '<div class="nh-item__price">' + (discounted ? '<s>' + fmt(it.original_line_price, f) + '</s>' : '') + '<strong>' + fmt(it.final_line_price, f) + '</strong>' +
            '<button type="button" class="nh-item__remove" data-nh-qty="0">Retirer</button></div>' +
          '</div>';
        }).join('');
        var saving = cart.original_total_price - cart.total_price;
        var srow = root.querySelector('[data-nh-cart-saving-row]') || document.querySelector('[data-nh-cart-saving-row]');
        if (srow) { srow.hidden = saving <= 0; srow.querySelector('[data-nh-cart-saving]').textContent = '− ' + fmt(saving, f); }
        var tot = root.querySelector('[data-nh-cart-total]') || document.querySelector('[data-nh-cart-total]');
        if (tot) tot.textContent = fmt(cart.total_price, f);
        var th = parseInt(root.getAttribute('data-free-threshold'), 10) || 0;
        var ship = root.querySelector('[data-nh-ship]');
        if (ship && th) {
          var left = th - cart.total_price;
          ship.hidden = !cart.item_count;
          ship.querySelector('[data-nh-ship-text]').innerHTML = left > 0 ? 'Plus que <strong>' + fmt(left, f) + '</strong> pour la livraison offerte' : '<strong>Livraison offerte</strong> sur votre commande';
          ship.querySelector('[data-nh-ship-bar]').style.width = Math.min(100, Math.round(cart.total_price / th * 100)) + '%';
        }
      });
    }
    function refresh() { return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { render(c); return c; }); }
    function change(line, qty) {
      targets().forEach(function (t) { t.classList.add('is-busy'); });
      return fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: line, quantity: qty }) })
        .then(function (r) { return r.json(); }).then(render)
        .finally(function () { targets().forEach(function (t) { t.classList.remove('is-busy'); }); });
    }
    function open() {
      var d = drawer(); if (!d) return;
      lastFocus = document.activeElement;
      d.hidden = false; document.documentElement.classList.add('nh-lock');
      requestAnimationFrame(function () { d.classList.add('is-open'); d.querySelector('.nh-drawer__panel').focus(); });
      refresh();
    }
    function close() {
      var d = drawer(); if (!d || d.hidden) return;
      d.classList.remove('is-open'); document.documentElement.classList.remove('nh-lock');
      setTimeout(function () { d.hidden = true; }, 250);
      if (lastFocus) lastFocus.focus();
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-nh-cart-open]') && drawer()) { e.preventDefault(); open(); return; }
      if (e.target.closest('[data-nh-drawer-close]')) { close(); return; }
      var q = e.target.closest('[data-nh-qty]');
      if (q) { change(parseInt(q.closest('[data-line]').getAttribute('data-line'), 10), Math.max(0, parseInt(q.getAttribute('data-nh-qty'), 10))); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    return { open: open, close: close, refresh: refresh, hasDrawer: function () { return !!drawer(); } };
  })();
  window.NHCart = NHCart;

  function init() {
    document.querySelectorAll('[data-nh-product]').forEach(function (scope) {
      var cta = scope.querySelector('[data-nh-cta-label]');
      if (cta) scope.setAttribute('data-cta', cta.textContent.trim());
    });
    tickCountdowns();
    setInterval(tickCountdowns, 1000);
    startBanners();
    if (document.querySelector('[data-nh-cartpage]') || document.querySelector('[data-nh-cart-count]')) NHCart.refresh();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  /* Éditeur de thème : réinitialiser quand une section est rechargée */
  document.addEventListener('shopify:section:load', tickCountdowns);
})();
